import { render, staticRenderFns } from "./Renovaciones.vue?vue&type=template&id=07df0a66"
import script from "./Renovaciones.vue?vue&type=script&lang=js"
export * from "./Renovaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports